module.exports = __webpack_public_path__ + "static/media/PictureHolder.c4ad6280.png";